import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-core-accordion',
  templateUrl: './core-accordion.component.html',
  styleUrls: ['./core-accordion.component.scss'],
})
export class CoreAccordionComponent {


  @Input() title: string = '';
  @Input() headerStyle: { [key: string]: string } = {};
  @Input() contentStyle: { [key: string]: string } = {};
  @Input() style: { [key: string]: string } = {};

  @Input() isOpen: boolean =false;
  @ContentChild('accordionHeader', { static: false })
  customHeaderTemplate!: TemplateRef<any>; // İçerik projeksiyonu kontrolü için

  toggleAccordion(): void {
    this.isOpen = !this.isOpen;
  }
}
